import React from 'react';
import API from '../../../../utils/API';
import FieldModal from '../../../../components/modals/fieldModal';
import InputField from '../../../../components/inputs/inputField'; // You'll need this for the rename input


class RenameGalleryModal extends React.Component { // Class name should be changed to RenameGalleryModal
    state = {
        submitting: false,
        isGeneralGallery: false,
        newName: '', 
        nameError: false 
    };

    renameGallery = async () => {
        const { eventId, orgId, galleries, markedGallery, toggle} = this.props; // Remove toggle from destructuring
        const { newName } = this.state;
        
        if (!newName || newName.trim() === '') {
            this.setState({ nameError: true });
            return;
        }
    
        this.setState({ submitting: true });
    
        try {
            await API().patch(`/Organizations/${orgId}/events/${eventId}/eventFeed/${markedGallery}`, {
                feedName: newName,
            });
            this.props.renameGallery(markedGallery, newName);
            toggle()

        } catch (err) {
            console.log(err);
            this.setState({ submitting: false });
        }
    };

    handleNameChange = (e) => {
        const newName = e.target.value;
        this.setState({ 
            newName,
            nameError: newName.trim() === '' 
        });
    };

    render() {
        const { isOpen, toggle, } = this.props;
        const { submitting, newName, nameError } = this.state;
        
        return (
            <div>
                <FieldModal
                    size="small"
                    isOpen={isOpen}
                    modalTitle={"Rename Gallery"}
                    bodyHeaderText={                        
                            <span>Enter a new name for the gallery:</span>
                    }
                    bodyContent={() => {
                        return (
                            <div>
                        
                                <InputField
                                    label="Name"
                                    value={newName}
                                    onChange={this.handleNameChange}
                                    required={true}
                                    errorTrigger={nameError}
                                    errorMessage={"Gallery name cannot be empty"}
                                />
                            </div>
                        )
                    }}
                    toggle={toggle}
                    actionButtonLabel={!submitting ? 'Rename' : 'Renaming...'}
                    actionButton={() => this.renameGallery()}
                    actionButtonDisabled={submitting || nameError || !newName}
                ></FieldModal>
            </div>
        );
    }
}

export default RenameGalleryModal; // Export with the correct component name